<template>
  <div class="SUMMARY">
    <div class="SUMMARY-HEADING">
      <span class="h4 c-gray70">
        <span class="d-none:mo">Your </span>Request Summary
      </span>
      <div
          class="d-flex ai-center cur-pointer c-bgray"
          selenium="show-details-button"
          @click="hideDetails = !hideDetails">
        <span>
          <template>{{ hideDetails ? 'Show' : 'Hide' }}</template> Details
        </span>
        <vk-icon :name="hideDetails ? 'chevrondown' : 'chevronup'" class="m-l-1 c-depot"/>
      </div>
    </div>
    <transition name="fade-up">
      <div v-if="!hideDetails" class="SUMMARY-DETAILS" selenium="summary-details-container">
        <div class="layout">
          <div class="layout-item is-12 is-6:t">
            <div class="h6 m-b-2" selenium="selected-pros-label">
              <span class="d-none:mo">Your </span>Selected Pros
            </div>
            <div class="d-flex:t">
              <template v-for="(profile, index) in selectedPublicProfiles">
                <div :key="profile.id" class="PROFILE-AVATAR">
                  <pro-avatar
                      :image="profile.service_provider.logo"
                      :selenium="`pro-name-avatar:${index+1}`"/>
                  <span
                      :selenium="`pro-bus-name-label:${index+1}`"
                      class="d-none:t m-l-2">
                    {{ profile.service_provider.business_name }}
                  </span>
                </div>
              </template>
            </div>
            <div class="d-none:mo m-t-2">
              <template v-for="profile in selectedPublicProfiles">
                <div :key="profile.id" class="text-md">
                  {{ profile.service_provider.business_name }}
                </div>
              </template>
            </div>
          </div>
          <div class="layout-item is-12 is-6:t">

            <div class="h6" selenium="subtask-location-label">
              {{ service.display_name }} /
              {{ location.city }},
              {{ location.state }}
              {{ $route.params.zipcode }}
            </div>

            <div class="text-md m-t-2" selenium="urgency-label">
              Start time: {{ $options.URGENCIES[selectedUrgencyId].text }}
            </div>

            <div v-if="notes" class="text-md m-t-2 WRAP-TEXT" selenium="notes-label">
              {{ notes }}
            </div>

            <gallery
                v-if="uploadedImages.length"
                :files="uploadedImages"
                class="m-t-2"
                selenium="photo-image"/>

          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _find from 'lodash/find';
import { URGENCIES } from '@/constants/urgencies';

export default {
  name: 'job-summary',
  URGENCIES,
  data () {
    return {
      hideDetails: true,
    };
  },
  computed: {
    ...mapGetters('jobrequest', [
      'service',
      'location',
    ]),
    ...mapGetters('jobrequest/details', [
      'selectedUrgencyId',
      'notes',
      'uploadedImages',
    ]),
    ...mapGetters('jobrequest/matches', [
      'publicProfiles',
      'selectedPublicProfilesIds',
    ]),
    selectedPublicProfiles () {
      return this.selectedPublicProfilesIds.map(id => _find(this.publicProfiles, { id }));
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  $border: 1px solid $color-gray30;

  .SUMMARY {
    background-color: #333;
    color: white;

    @include tablet {
      background-color: white;
      color: black;
    }
  }

  .WRAP-TEXT{
    word-break: break-word;
    white-space: normal;
}
  .SUMMARY-HEADING {
    @include padding-y(2);
    @include padding-x(2, 4);
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include tablet() {
      border: $border;
    }
  }

  .SUMMARY-DETAILS {
    @include padding-y(2);
    @include padding-x(2, 4);

    @include tablet() {
      border-left: $border;
      border-right: $border;
      border-bottom: $border;
    }
  }

  .PROFILE-AVATAR {
    @include margin-bottom(2, 0);
    display: flex;
    align-items: center;

    & + & {
      @include margin-left(0, 2);
    }
  }
</style>
